import { ShopImport } from './Import'
const { RoutesMap, ShopCategoryList, ShopSubCategoryList, ShopProductList } = ShopImport

const ShopRoute = () => {
    return [
        {
            path: RoutesMap.SHOP_CATEGORY_LIST.path,
            element: <ShopCategoryList />
        },
        {
            path: RoutesMap.SHOP_SUB_CATEGORY_LIST.path,
            element: <ShopSubCategoryList />
        },
        {
            path: RoutesMap.SHOP_PRODUCT_LIST.path,
            element: <ShopProductList />
        },
    ]
}

export default ShopRoute;
